import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { welcomeRoute } from "../route-names";
import { ApiAboutService } from "../Services/api-about.service";

@Injectable()
export class CanActivateElection  {
    private election_start: Date;
    private election_close: Date;
    constructor(
        private router: Router,
        private aboutService: ApiAboutService
        ) {
            this.election_start = this.aboutService.startTimeDate;
            this.election_close = this.aboutService.endTimeDate;
        }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        let timeNow = new Date();
        if (this.election_start <= timeNow && timeNow <= this.election_close) {
            return true
        } else {
            return this.router.createUrlTree(welcomeRoute);
        }
    }
}